import React, { useState, memo, useEffect } from "react";
import { Row, Col, Card, CardBody, Button } from "reactstrap";

import FullMockDetails from "components/FullTest/MockOperations/FullMockDetails";
import MockTest from "components/FullTest/MockOperations/MockTest";
import TestFinished from "components/FullTest/MockOperations/TestFinished";
import { set } from "react-ga";

const TEST_FINISHED = 3;
const Mock = memo(function Mock({
  setStep,
  params,
  mockData,
  defaultCheckPoint,
}) {
  // console.log(mockData, "mockData in mock.jsx");
  // console.log(setStep, "setStep in mock.jsx");
  // console.log(params, "params in mock.jsx");
  // console.log(defaultCheckPoint, "defaultCheckPoint in mock.jsx");
  const [checkPoint, setCheckPoint] = useState(defaultCheckPoint);
  const [nextFlag, setNextFlag] = useState(false);

  const nextButton = (e) => {
    setCheckPoint((prev) => prev + 1);
    setNextFlag(false);
  };

  const startFullMockSection = () => {
    let section = 1;
    const skip = parseInt(mockData.skip);

    if (parseInt(params.pending)) {
      if (skip < 2) {
        section = skip + 1;
      } else if (skip === 2) {
        section = 4;
      } else {
        section = 0;
      }
    }
    return section;
  };

  return (
    <>
      {checkPoint === 1 && (
        <div className="content questionsArea deviceTestPage">
          <Row>
            <Col xs={12}>
              <Card>
                <CardBody>
                  <FullMockDetails
                    setCheckPoint={setCheckPoint}
                    mock={mockData}
                    setNextFlag={setNextFlag}
                  />
                </CardBody>
              </Card>
            </Col>

            <Col xs={12}>
              <div className="bottomBtns">
                <Row>
                  <Col xs={9}></Col>
                  <Col xs={3}>
                    <Button
                      color="primary"
                      disabled={!nextFlag}
                      onClick={nextButton}
                      size="xs"
                    >
                      NEXT
                    </Button>
                    {/*this.state.startFlag && <Button color="primary" onClick={this.props.showTest} size="xs">Next</Button>*/}
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </div>
      )}

      {checkPoint === 2 && (
        <MockTest
          setCheckPoint={setCheckPoint}
          mock={mockData}
          pending={parseInt(params.pending)}
          startSection={startFullMockSection()}
        />
      )}

      {checkPoint === TEST_FINISHED && <TestFinished />}
    </>
  );
});

export default Mock;
